import { render, staticRenderFns } from "./garden.vue?vue&type=template&id=f9b24682&"
import script from "./garden.vue?vue&type=script&lang=js&"
export * from "./garden.vue?vue&type=script&lang=js&"
import style0 from "./garden.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports